'use strict';

angular.module('mandaeApp')
  .controller('ModalAreaPostagemCtrl', function ($uibModalInstance, $scope, Cep, localStorageService) {

    $scope.mensagem = Cep.obsColeta();

    $scope.fechar = function () {
      $uibModalInstance.dismiss();
    }

    $scope.dontShowAgain = function(alert) {
      if (localStorageService.cookie.get(alert) == null) {
        localStorageService.cookie.set(alert, true);
      } else if (localStorageService.cookie.get(alert) === true) {
        localStorageService.cookie.remove(alert);
      }
    }

  });
